import { AppThunk } from "../states/generateStore";
import { suiteCrmUrl, userAuth } from "./constants";
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';
import loadingSlice from '../states/loading/slice';

const onLogin = (name: string, pass: string): AppThunk => 
    async (dispatch, getStore) => {
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('pass', pass);
      
            const response = await fetch(suiteCrmUrl.concat(userAuth),
              { 
                method: 'POST',
                body: formData
              }
            );
      
            const result = await response.json();
            if (result) {
              // Success
              if (result.code === 0) {
                let userToken = {
                  user: {
                    user_name: result.content.user_name,
                    first_name: result.content.first_name,
                    last_name: result.content.last_name,
                  }, 
                  token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
                };
      
                localStorage.setItem('token', JSON.stringify(userToken));
                dispatch(shellSlice.actions.updateIsAuth(true));
                dispatch(loadingSlice.actions.updateLoading({isOpen: true, message: ''}));
              } else {
                // Fail
                dispatch(snackBarSlice.actions.updateAlert({message: result.message, severity: "warning"}));
                dispatch(snackBarSlice.actions.updateSnackBar(true));
              }
            } else {
              // show warning
              dispatch(snackBarSlice.actions.updateAlert({message: "Unable to login", severity: "warning"}));
              dispatch(snackBarSlice.actions.updateSnackBar(true));
            }
        } catch (err) {
            console.log(err);
            // show error
            dispatch(snackBarSlice.actions.updateAlert({message: "onLogin: Can not login", severity: "error"}));
            dispatch(snackBarSlice.actions.updateSnackBar(true));
        }

}

export default onLogin;